import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import { TenantWebsitesBasicInfoComponent } from './tenant-website-basic-info.commponent';
import TenantWebsiteCardComponent from './tenant-website-cards.components';


export const TenantWebsitesComponent = ({ departments,stores,Id,onDelete,additionButtons,onEdit,rowData,columnDefs,selectedTenantWebsites,handleInnerFormChange,websites,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<TenantWebsitesBasicInfoComponent 
        onInnerFormChange={handleInnerFormChange}
        selectedTenantWebsites ={selectedTenantWebsites} 
        stores={stores}
        websites={websites}
        departments={departments} />,
        isVisible: Id == 0 ? true : false,
    },
    {
        id:2,
        title:' Tenant Website Cards ',
        component:<TenantWebsiteCardComponent 
        onDelete={onDelete}
        additionButtons={additionButtons}
        rowData={rowData}
        columnDefs={columnDefs}
        onEdit={onEdit}
     />,
     isVisible: Id > 0 ? true : false,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
      {Id == 0 ? (
      <div className='flex w-full justify-end items-end'>
     
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>

             
         
               <button
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                 onClick={handleFormSubmit}
               
                 type="submit"
             >
               Save
             </button>
        </div>
        ) : null}
       </div>
  )
}
export default TenantWebsitesComponent;
